import { useTranscriptionsState } from '@modules/transcriptions/useTranscriptionsState';
import { useMemo } from 'react';
import { useAuthContext } from 'src/auth/useAuthContext';
import { useLivekitRTCState } from 'src/provider/VoiceChannel/livekit/useLivekitRTCState';

export const useTranscriptionNotesState = () => {
  const { activeVoiceChannel } = useLivekitRTCState();
  const { user } = useAuthContext();

  const { activeTranscriptionChannelId, activeTranscriptionOwner } =
    useTranscriptionsState();

  const isTranscriptionStarted =
    !!activeTranscriptionChannelId &&
    activeTranscriptionChannelId === activeVoiceChannel?.channel?._id;
  const startedByCurrentUser = activeTranscriptionOwner === user?._id;

  return useMemo(
    () => ({
      isTranscriptionStarted,
      startedByCurrentUser,
    }),
    [isTranscriptionStarted, startedByCurrentUser],
  );
};
